import React, { Suspense } from "react"
import { createRootRoute, Outlet } from "@tanstack/react-router"
import { DarkModeProvider } from "@/contexts/DarkModeProvider"
import { AuthProvider } from "@/contexts/AuthProvider"
import { Toaster } from "@/components/ui/sonner"
import { TooltipProvider } from "@/components/ui/tooltip"
import NotFound from "@/routes/-pages/NotFound"

/**
 * Root route layout that wires providers and suspense handling.
 *
 * @returns Shared application layout with nested routes rendered via an outlet.
 */
const RootLayout: React.FC = () => {
  return (
    <DarkModeProvider>
      <TooltipProvider delayDuration={400} skipDelayDuration={300}>
        <Toaster position="top-center" />
        <AuthProvider>
          <Suspense fallback={<div className="min-h-screen" />}>
            <Outlet />
          </Suspense>
        </AuthProvider>
      </TooltipProvider>
    </DarkModeProvider>
  )
}

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFound,
})
